module.exports = __webpack_public_path__ + "static/logo-76dd96dc102c10a61adca4a7d9a770b1.png";